
<template>
<div class="tabbed-content" :class="{disabled: (user.user_role == 'charity')}">
  <div class="columns">
    <div class="col">
      <chc-input v-if="user.user_role == 'admin'" v-model="data.status" label="Status" :error="errors.status"
                   format="combo" :autoCompleteValues="$store.state.constants.vehicle.vehicle_status"></chc-input>
      <chc-input v-model="data.donation_type" :error="errors.donation_type" label="Donation Type" format="combo"
                 :autoCompleteValues="$store.state.constants.vehicle.donation_type"></chc-input>
      <chc-input v-model="data.vin" :error="errors.vin" label="VIN"
                 @blur="pullVin"></chc-input>
      <chc-input v-model="data.vehicle_year" :error="errors.vehicle_year" :isLoading="loadingVin" label="Vehicle Year" ref="vehicleYear"></chc-input>
      <chc-input v-model="data.vehicle_make" :error="errors.vehicle_make" :isLoading="loadingVin" label="Vehicle Make" ref="vehicleMake"></chc-input>
      <chc-input v-model="data.vehicle_model" :error="errors.vehicle_model" :isLoading="loadingVin" label="Vehicle Model" ref="vehicleModel"></chc-input>
      <chc-input v-model="data.vehicle_color" :error="errors.vehicle_color" label="Color" format="combo"
                 :autoCompleteValues="$store.state.constants.vehicle.color" ref="vehicleColor"></chc-input>
      <chc-input v-model="data.mileage" :error="errors.mileage" label="Mileage"></chc-input>
      <chc-input v-model="data.drivable" :error="errors.drivable" label="Drivable" format="combo"
                 :autoCompleteValues="$store.state.constants.vehicle.drivable"></chc-input>
      <chc-input v-model="data.tire_condition" :error="errors.tire_condition" label="Tire Condition" format="combo"
                 :autoCompleteValues="$store.state.constants.vehicle.tire_condition"></chc-input>
      <chc-input v-model="data.running" :error="errors.running" label="Running" format="combo"
                 :autoCompleteValues="$store.state.constants.vehicle.running"></chc-input>
      <chc-input v-model="data.battery_and_key_or_keyfob_available" :error="errors.battery_and_key_or_keyfob_available" label="Vehicle's battery works and key or keyfob is available?" format="combo"
                 :autoCompleteValues="$store.state.constants.vehicle.battery_and_key_or_keyfob_available"></chc-input>

      <chc-input v-model="data.all_tires_inflated" :error="errors.all_tires_inflated" label="All tires inflated?" format="combo"
                 :autoCompleteValues="$store.state.constants.vehicle.all_tires_inflated"></chc-input>
      <chc-multiselect-input
        v-if="data.all_tires_inflated === 0"
        placeholder="Location of flat tires"
        fieldLabel="Location of flat tires"
        v-model="data.flat_tires_location"
        track-by="value"
        label="label"
        :options="$store.state.constants.vehicle.flat_tires_location"
        :multiple="true"
        :error="errors.flat_tires_location"
        :allow-empty="false"
        :hide-selected="false"
        :close-on-select="false"
      />

      <chc-input v-model="data.wheels_removed" :error="errors.wheels_removed" label="Vehicle has one or more wheels that are removed?" format="combo"
                 :autoCompleteValues="$store.state.constants.vehicle.wheels_removed"></chc-input>
      <chc-multiselect-input
        v-if="data.wheels_removed === 1"
        placeholder="Location of removed wheels"
        fieldLabel="Location of removed wheels"
        v-model="data.wheels_removed_location"
        track-by="value"
        label="label"
        :error="errors.wheels_removed_location"
        :options="$store.state.constants.vehicle.wheels_removed_location"
        :multiple="true"
        :allow-empty="false"
        :hide-selected="false"
        :close-on-select="false"
      />

      <chc-input v-model="data.body_panels_intact" :error="errors.body_panels_intact" label="Vehicle's body panels are intact?" format="combo"
                 :autoCompleteValues="$store.state.constants.vehicle.body_panels_intact"></chc-input>
      <chc-multiselect-input
        v-if="data.body_panels_intact === 0"
        placeholder="Location of body panel damage"
        fieldLabel="Location of body panel damage"
        v-model="data.body_panels_damage_location"
        track-by="value"
        label="label"
        :options="$store.state.constants.vehicle.body_panels_damage_location"
        :multiple="true"
        :error="errors.body_panels_damage_location"
        :allow-empty="false"
        :hide-selected="false"
        :close-on-select="false"
      />

      <chc-input v-model="data.body_damage_free" :error="errors.body_damage_free" label="Body is free of damage larger than size of baseball?" format="combo"
                 :autoCompleteValues="$store.state.constants.vehicle.body_damage_free"></chc-input>
      <chc-multiselect-input
        v-if="data.body_damage_free === 0"
        placeholder="Location of body damage"
        fieldLabel="Location of body damage"
        v-model="data.body_damage_location"
        track-by="value"
        label="label"
        :options="$store.state.constants.vehicle.body_damage_location"
        :multiple="true"
        :error="errors.body_damage_location"
        :allow-empty="false"
        :hide-selected="false"
        :close-on-select="false"
      />

      <chc-input v-model="data.mirrors_lights_glass_intact" :error="errors.mirrors_lights_glass_intact" label="Vehicle's mirrors, lights, and glass are intact?" format="combo"
                 :autoCompleteValues="$store.state.constants.vehicle.mirrors_lights_glass_intact"></chc-input>
      <chc-multiselect-input
        v-if="data.mirrors_lights_glass_intact === 0"
        placeholder="Location of mirrors, lights, and/or glass damage"
        fieldLabel="Location of mirrors, lights, and/or glass damage"
        v-model="data.mirrors_lights_glass_damage_location"
        track-by="value"
        label="label"
        :options="$store.state.constants.vehicle.mirrors_lights_glass_damage_location"
        :multiple="true"
        :error="errors.mirrors_lights_glass_damage_location"
        :allow-empty="false"
        :hide-selected="false"
        :close-on-select="false"
      />
      <p></p>
    </div>
    <div class="col">
      <chc-input v-model="data.transmission_type" :error="errors.transmission_type" label="Transmission Type" format="combo"
                 :isLoading="loadingVin"
                 :autoCompleteValues="$store.state.constants.vehicle.transmission_type" ref="transmissionType"></chc-input>
      <chc-input v-model="data.drive_train" :error="errors.drive_train" label="Drive Train" format="combo"
                 :isLoading="loadingVin"
                 :autoCompleteValues="$store.state.constants.vehicle.drive_train" ref="driveTrain"></chc-input>
      <chc-input v-model="data.mechanical_condition" :error="errors.mechanical_condition" label="Mechanical Condition" format="combo"
                 :autoCompleteValues="$store.state.constants.vehicle.mechanical_condition"></chc-input>
      <chc-input v-model="data.body_class" :error="errors.body_class" label="Body Class" :isLoading="loadingVin" ref="bodyClass"></chc-input>
      <chc-input v-model="data.doors" :error="errors.doors" label="Number of Doors" format="combo"
                     :isLoading="loadingVin"
                     :autoCompleteValues="$store.state.constants.vehicle.doors" ref="numDoors"></chc-input>
      <chc-input v-model="data.body_condition" :error="errors.body_condition" label="Body Condition" format="combo"
                 :autoCompleteValues="$store.state.constants.vehicle.body_condition"></chc-input>
      <chc-input v-model="data.rust_condition" :error="errors.rust_condition" label="Rust Condition" format="combo"
                 :autoCompleteValues="$store.state.constants.vehicle.rust_condition"></chc-input>
      <chc-input v-model="data.paint_condition" :error="errors.paint_condition" label="Paint Condition" format="combo"
                 :autoCompleteValues="$store.state.constants.vehicle.paint_condition"></chc-input>
      <chc-input v-model="data.interior_condition" :error="errors.interior_condition" label="Interior Condition" format="combo"
                 :autoCompleteValues="$store.state.constants.vehicle.interior_condition"></chc-input>
      <chc-input v-model="data.missing_parts" :error="errors.missing_parts" label="Missing Parts"></chc-input>
      <chc-input v-model="data.other_conditions" :error="errors.other_conditions" label="Other Conditions"></chc-input>
      <chc-input v-model="data.title_state" :error="errors.title_state" label="Title State" format="combo"
                 :autoCompleteValues="$store.state.constants.us_states_list"></chc-input>
      <chc-input v-model="data.title_status" :error="errors.title_status" label="Title Status" format="combo"
                 :autoCompleteValues="$store.state.constants.vehicle.title_status"></chc-input>

      <chc-input v-model="data.title_type" :error="errors.title_type" label="Title Type" format="combo"
                 :autoCompleteValues="$store.state.constants.vehicle.title_type"></chc-input>

      <chc-input v-model="data.interior_intact" :error="errors.interior_intact" label="Interior intact?" format="combo"
                 :autoCompleteValues="$store.state.constants.vehicle.interior_intact"></chc-input>

      <chc-input v-model="data.flood_fire_damage_free" :error="errors.flood_fire_damage_free" label="Vehicle is free of flood or fire damage?" format="combo"
                 :autoCompleteValues="$store.state.constants.vehicle.flood_fire_damage_free"></chc-input>

      <chc-input v-model="data.engine_transmission_condition" :error="errors.engine_transmission_condition" label="Vehicle's engine and transmissions are intact, missing parts or removed?" format="combo"
                 :autoCompleteValues="$store.state.constants.vehicle.engine_transmission_condition"></chc-input>

      <chc-input v-model="data.usage" :error="errors.usage" label="Vehicle Usage" format="combo"
                 :autoCompleteValues="$store.state.constants.vehicle.usage"></chc-input>
    </div>
  </div>
  <div class="columns" v-if ="user.user_role !== 'charity'">
    <div class="col">
      <span v-if="hasErrors" class="error-message error-block">
        There were errors processing the form. Please fix the fields above.
      </span>
      <div class="field buttons submit-section">
        <input @click="submit" class="btn" type="submit" value="Save Changes">
      </div>
      <transition name="fade">
        <p v-if="saved" class="success-message">Changes Saved</p>
      </transition>
      <p></p>
    </div>
  </div>
</div>
</template>

<script>
import store from '@/store'
import auth from '@/auth'
import Multiselect from 'vue-multiselect'
import ChcMultiselectInput from '../Widgets/ChcMultiselectInput.vue'
import VehicleFormMixin from './VehicleFormMixin'

export default {
  name: 'VehicleDetailInfo',
  components: {ChcMultiselectInput, Multiselect},
  mixins: [VehicleFormMixin],
  data () {
    return {
      user: auth.user,
      errors: {
      },
      hasErrors: false,
      loadingVin: false,
      currentVin: this.data.vin,
      saved: false
    }
  },
  props: ['vehicleId', 'data'],
  methods: {
    submit () {
      const dataForSubmission = this.cleanVehicleMultiSelectLocationData(this.data)
      store.functions.vehicles.editVehicleDetailInfo(this.vehicleId, dataForSubmission, (errors) => {
        this.errors = errors
        this.saved = false
        this.hasErrors = true
      }).then(() => {
        this.$toast.success('Changes saved.')
        this.hasErrors = false
        this.errors = {}
        this.saved = true
        this.$emit('refresh')
        setTimeout(() => {
          this.saved = false
        }, 500)
      }).catch(() => {
        this.$toast.error('Failed to save information...')
      })
    },
    pullVin () {
      if (this.data.vin === this.currentVin) return
      this.loadingVin = true
      store.functions.vehicles.vinInfo(this.data, (errors) => {
        this.loadingVin = false
      }).then((response) => {
        this.$refs.vehicleMake.forceUpdateValue(response.data.vehicle_make)
        this.$refs.vehicleModel.forceUpdateValue(response.data.vehicle_model)
        this.$refs.vehicleYear.forceUpdateValue(response.data.vehicle_year)
        this.$refs.vehicleColor.forceUpdateValue(response.data.vehicle_color)
        this.$refs.transmissionType.forceUpdateValue(response.data.transmission_type)
        this.$refs.driveTrain.forceUpdateValue(response.data.drive_train)
        this.$refs.bodyClass.forceUpdateValue(response.data.body_class)
        this.$refs.numDoors.forceUpdateValue(response.data.doors)
        this.currentVin = this.data.vin
        this.loadingVin = false
      }).catch(() => {
        this.$refs.vehicleMake.forceUpdateValue(null)
        this.$refs.vehicleModel.forceUpdateValue(null)
        this.$refs.vehicleYear.forceUpdateValue(null)
        this.$refs.vehicleColor.forceUpdateValue(null)
        this.$refs.transmissionType.forceUpdateValue(null)
        this.$refs.bodyClass.forceUpdateValue(null)
        this.$refs.numDoors.forceUpdateValue(null)
        this.loadingVin = false
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
    opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transition: opacity 3s;
    opacity: 0;
}

.disabled div {
    pointer-events: none;
    user-select: none;
}
.disabled div div {
  pointer-events: none;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Vehicle/VehicleDetailInfo.vue